import React from 'react';
import { useTranslation } from 'react-i18next';
import { LoadMore } from '@/components/Icons/LoadMore';
import { Spinner } from '@/components/Spinner';

interface Props {
  isMobile: boolean;
  hasMorePages: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => void;
}

export const MailLoadMore: React.FC<Props> = ({
  isMobile,
  hasMorePages,
  isLoadingMore,
  onLoadMore,
}) => {
  const { t } = useTranslation();

  const noticeKey = isMobile ? 'mail.storageTooltip' : 'mail.storageNotice';

  if (isMobile && !hasMorePages && !isLoadingMore) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-2 px-4 pt-4 pb-8">
      {hasMorePages && !isLoadingMore && (
        <button
          type="button"
          onClick={onLoadMore}
          className="text-subhead-14 flex h-12 cursor-pointer items-center gap-2 text-primary"
        >
          <LoadMore className="size-4 shrink-0" />
          {t('mail.loadMore')}
        </button>
      )}

      {isLoadingMore && (
        <div className="flex h-12 items-center justify-center text-primary">
          <Spinner />
        </div>
      )}

      <p className="text-caption-12 text-center text-subtle-foreground">
        {t(noticeKey)}
      </p>
    </div>
  );
};
